import { useContext, type FC } from "react";

import {
  BookingConflictErrorType,
  type IApprovalBookingConflict,
} from "@ryde/shared";

import { BulkPreviewStepConflictsContext } from "../bulk-preview-step-conflicts.context";
import { RejectedBookings } from "./rejected-bookings";
import { RejectedBookingsInsideBookingTable } from "./rejected-bookings-inside-bookings-table";
import { RejectedBookingsOverlappingTable } from "./rejected-bookings-overlapping-table";
import { RejectedBookingsPassengerIneligibleTable } from "./rejected-bookings-passenger-ineligible-table";
import { RejectedBookingsStatusMismatchTable } from "./rejected-bookings-status-mismatch-table";
import { RejectedBookingsWithinProductionLock } from "./rejected-bookings-within-production-lock";

interface IResolveRejectedBookingTableProps {
  errorType: IApprovalBookingConflict["errorType"];
}

export const ResolveRejectedBookingTable: FC<
  IResolveRejectedBookingTableProps
> = ({ errorType }) => {
  const { isGapConflictApprovable } = useContext(
    BulkPreviewStepConflictsContext,
  );

  switch (errorType) {
    case BookingConflictErrorType.passengerIneligible:
    case BookingConflictErrorType.passengerLocationIneligible:
    case BookingConflictErrorType.passengerTimeIneligible:
      return <RejectedBookingsPassengerIneligibleTable />;
    case BookingConflictErrorType.gapSingleOverlappingBookingBToB:
    case BookingConflictErrorType.gapSingleOverlappingBookingBToA:
    case BookingConflictErrorType.gapSingleOverlappingBookingAToA:
      return (
        <RejectedBookingsOverlappingTable
          isApprovable={isGapConflictApprovable}
        />
      );
    case BookingConflictErrorType.existingRide:
    case BookingConflictErrorType.overlappingBooking:
      return <RejectedBookingsOverlappingTable />;
    case BookingConflictErrorType.insideBooking:
      return <RejectedBookingsInsideBookingTable />;
    case BookingConflictErrorType.withinProductionLock:
      return <RejectedBookingsWithinProductionLock />;
    // RYDE-8171: a meal-only row that cannot be booked is listed by passenger and date only - it has no approval action.
    case BookingConflictErrorType.mealOnlyShiftRequiresMeal:
    case BookingConflictErrorType.mealOnlyBookingShiftMismatch:
      return <RejectedBookings />;
    case BookingConflictErrorType.statusMismatch:
      return <RejectedBookingsStatusMismatchTable />;
    default:
      return <RejectedBookings />;
  }
};
